import { render } from "./PdfReportUpload.vue?vue&type=template&id=498a58ac"
import script from "./PdfReportUpload.vue?vue&type=script&lang=js"
export * from "./PdfReportUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__